import { Link } from "react-router-dom";
import styles from "./RulesAndPolicyText.module.scss";

export const RulesAndPolicyText = () => {
  return (
    <div className={styles.textWrapper}>
      <p className={styles.text}>
        Нажимая на кнопку Вы подтверждаете, что ознакомлены и принимаете условия{' '}
        <Link to="/privacy-policy" className={styles.link}>
          политики конфиденциальности
        </Link>
        {' '}
        и
        {' '}
        <Link to="/rules" className={styles.link}>
          правила клуба
        </Link>
      </p>
    </div>
  );
};